import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { VARIANT_A } from '../experiments/experimentDefaults';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from '../signup-data/DATA';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { Step } from '../views/Step';
import { renderLandingPageTitle } from './renderLandingPageTitle';
import { useLandingPage } from './useLandingPage';

const EmailOnlyLandingPageView = () => {
  const stepKey = Step.EmailOnlyLandingPage;
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isMobile
  } = useResponsiveness();
  const {
    parameter
  } = useExperiment(ExperimentKeys.ACQ122, TrackWhen.enrolled);
  const buttonText = parameter === VARIANT_A ? `button.next` : `${stepKey}.buttonLabel`;

  const renderUserInfo = () => /*#__PURE__*/_jsx(SignupDataInputForm, {
    autoFocus: false,
    buttonProps: {
      label: buttonText
    },
    dataKey: Data.Email,
    submit: chooseEmailSignUp
  }, Data.Email);

  const renderContent = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OAuthSignupSection, {}), renderUserInfo()]
  });

  const renderFooter = () => /*#__PURE__*/_jsx(PrivacyBanner, {});

  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.LandingPage,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [renderLandingPageTitle({
          isMobile
        }), renderContent(), renderFooter()]
      })
    })
  });
};

export default EmailOnlyLandingPageView;